import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';

import generateFoodItemPrice from '../../utils/generateFoodItemPrice';
import MenuItemInformation from '../common/menuitem/MenuItemInformation';
import MenuItemChoice from '../common/menuitem/MenuItemChoice';
import MenuItemModifier from '../common/menuitem/MenuItemModifier';
import FoodItemAddonSelection from './FoodItemAddonSelection';
import MenuItemInstructions from '../common/menuitem/MenuItemInstructions';
import MenuItemSubmitButton from '../common/menuitem/MenuItemSubmitButton';
import MenuItemAdded from '../common/menuitem/MenuItemAdded';
import { ModalCloseButton } from '../common/ModalCloseButton';
import { closeFoodItem } from '../../actions/modals';
import { 
    updateSingleChoiceSelection, 
    updateMultipleChoiceSelection, 
    cartItemReset, 
    cartItemUpdateId, 
    cartItemLoadChoices, 
    cartItemAddonAdd, 
    cartItemAddonRemove, 
    cartItemUpdatePrice,
    updateSingleModifierSelection,
    cartItemAddModifierItem,
    cartItemRemoveModifierItem
} from '../../actions/cartItem';

import { setCartPanel, setFoodItemPanel } from '../../actions/panels';

class ViewFoodItemModal extends React.Component {

    constructor(props) {
        super(props);

        this.isSelected = this.isSelected.bind(this);
        this.isMultipleSelected = this.isMultipleSelected.bind(this);
        this.isPriceSelected = this.isPriceSelected.bind(this);
        this.updateSingleChoiceSelection = this.updateSingleChoiceSelection.bind(this);
        this.updateMultipleChoiceSelection = this.updateMultipleChoiceSelection.bind(this);
        this.isModifierSelected = this.isModifierSelected.bind(this);
        this.updateSingleModifierSelection = this.updateSingleModifierSelection.bind(this);
        this.updateMultipleModifierSelection = this.updateMultipleModifierSelection.bind(this);
        this.showCompleted = this.showCompleted.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCart = this.handleCart.bind(this);

        this.state = {
            showComplete: false
        };
    }

    showCompleted() {
        this.props.dispatch(setFoodItemPanel('completed'));
    }

    handleClose() {
        this.props.dispatch(closeFoodItem());
    }

    handleCart() {
        this.props.dispatch(setCartPanel(''));
        this.props.history.push('/'+this.props.sitename+'/'+this.props.locationId+'/cart');
        this.props.dispatch(closeFoodItem());
    }

    isPriceSelected(price_id) {
        return this.props.cartItem.price_id == price_id;
    }

    isSelected(choice_id, item_id) {

        const selectedChoice = this.props.cartItem.choices.find((theChoice) => {
            return theChoice.id == choice_id;
        });

        if (selectedChoice) {
            return selectedChoice.item_id == item_id;
        }
        
        return false;
    }

    isMultipleSelected(choice_id, item_id) {
        const selectedChoice = this.props.cartItem.choices.find((theChoice) => {
            return theChoice.id == choice_id;
        });
        
        if (selectedChoice) {
            // iterate through the items and determine if it's there
            let isFound = false;
            selectedChoice.items.forEach((theItem) => {
                if (theItem == item_id) {
                    isFound = true;
                }
            });
            
            return isFound;
        }

        return false;
    }

    updateSingleChoiceSelection(choice_id, selection) {
        this.props.dispatch(updateSingleChoiceSelection(choice_id, selection));
    }

    updateMultipleChoiceSelection(choice_id, selections, choices, selection) {
        this.props.dispatch(updateMultipleChoiceSelection(choice_id, selections, choices, selection));
    }

    isModifierSelected(foodItemModifierID, itemID){
                
        const selectedFoodItemModifier = this.props.cartItem.modifiers.find((foodItemModifier) => {
            return foodItemModifier.foodItemModifierID == foodItemModifierID;
        });

        if (selectedFoodItemModifier) {
            return selectedFoodItemModifier.items.find((item) => {
                return item.id == itemID;
            });
        }
        
        return false;

    }

    updateSingleModifierSelection(foodItemModifierID, item) {
        this.props.dispatch(updateSingleModifierSelection(foodItemModifierID, item));
    }

    updateMultipleModifierSelection(foodItemModifierID, item) {
        
        const selectedFoodItemModifier = this.props.cartItem.modifiers.find((foodItemModifier) => {
            return foodItemModifier.foodItemModifierID == foodItemModifierID;
        });

        if(selectedFoodItemModifier){

            const selectedItem = selectedFoodItemModifier.items.find((modItem) => {
                return modItem.id == item.id;
            });

            if(selectedItem){
                this.props.dispatch(cartItemRemoveModifierItem(foodItemModifierID, item));
            }else if(selectedFoodItemModifier.items.length < selectedFoodItemModifier.max){
                this.props.dispatch(cartItemAddModifierItem(foodItemModifierID, {
                    id: item.id,
                    name: item.name,
                    price: item.prices[0].price
                }));
            }

        }

    }

    componentDidMount() {
        // nothing here yet, delete if not required
        this.props.dispatch(cartItemReset());
        this.props.dispatch(cartItemUpdateId(this.props.foodItem.id));

        if (this.props.foodItem.choices) {
            // set up the default state of the choices
            const initialChoiceSelections = this.props.foodItem.choices.map((theChoice) => {
                if (theChoice.is_multiple == 1) {
                    return {
                        id: theChoice.id,
                        is_multiple: 1,
                        item_name: 'No Items selected.',
                        item_price: 0.00,
                        items: [],
                        max_choices: theChoice.max_choices
                    }
                }
                else {
                    return {
                        id: theChoice.id,
                        name: theChoice.name,
                        is_multiple: 0,
                        item_name: theChoice.selections[0].name,
                        item_price: theChoice.selections[0].price,
                        item_id: theChoice.selections[0].id,
                    }
                }
            });

            this.props.dispatch(cartItemLoadChoices(initialChoiceSelections));
        }

        // set up the default state of the price
        if (this.props.foodItem.prices && this.props.foodItem.prices.length > 0) {
            this.props.dispatch(cartItemUpdatePrice(this.props.foodItem.prices[0].id, this.props.foodItem.prices[0].name, this.props.foodItem.prices[0].price));
        }
    }

    renderFoodItemPricesAndChoices() {
        if (this.props.foodItem.prices && this.props.foodItem.prices.length > 1 || (this.props.foodItem.choices && this.props.foodItem.choices.length > 0 && this.props.cartItem.choices.length > 0)) {

            return (
                <div>
                    {(this.props.foodItem.prices && this.props.foodItem.prices.length > 1) && (
                        <div>
                            <div className="section-title">
                                <p className="selectionTitleText">What Size?</p>
                            </div>
                            
                            <div className="choice-selection-window">
                                {this.props.foodItem.prices.map((price) => {
                                    return (
                                        <div key={price.id} className="menu-item-choice-window">
                                            <input 
                                                type="checkbox"
                                                onClick={() => { 
                                                    this.props.dispatch(cartItemUpdatePrice(price.id, price.name, price.price));
                                                }}
                                                checked={this.isPriceSelected(price.id)}
                                                id={"price-"+price.id}
                                            />
                                            <label className="selectionLabelText" for={"price-"+price.id}>{price.name + " - " + price.price}</label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    

                    {this.props.foodItem.choices && this.props.foodItem.choices.map((theChoice) => {

                        return (
                            <MenuItemChoice
                                key={theChoice.id}
                                isSelected={this.isSelected}
                                isMultipleSelected={this.isMultipleSelected}
                                updateSingleChoiceSelection={this.updateSingleChoiceSelection}
                                updateMultipleChoiceSelection={this.updateMultipleChoiceSelection}
                                choice={theChoice}
                                selection={this.props.cartItem.choices.find((theSelection) => {
                                    return theChoice.id == theSelection.id;
                                })}
                            >
                                {theChoice.name}
                            </MenuItemChoice>
                        );
                    })}
                </div>
            )
        }
    }

    renderModifiers(){

        if(this.props.foodItem.modifiers && this.props.foodItem.modifiers.length > 0){
            return (
                <div>
                    {this.props.foodItem.modifiers.map((foodItemModifier) => {
                        return (
                            <MenuItemModifier
                                key={foodItemModifier.id}
                                isModifierSelected={this.isModifierSelected}
                                updateSingleModifierSelection={this.updateSingleModifierSelection}
                                updateMultipleModifierSelection={this.updateMultipleModifierSelection}
                                foodItemModifier={foodItemModifier}
                            >
                                {foodItemModifier.modifier.name}
                            </MenuItemModifier>
                        );
                    })}
                </div>
            )
        }

    }

    renderFoodItemAddons() {
        if (this.props.foodItem.addons && this.props.foodItem.addons.length > 0) {
            return (
                <div>
                    <div className="section-title">
                        <p className="selectionTitleText">ADD-ONS</p>
                    </div>
                    {this.props.foodItem.addons.map((theAddon) => {
                        return (
                            <FoodItemAddonSelection
                                onPress={() => {
                                    
                                    if (this.props.cartItem.addons.some((addon) => addon == theAddon.id)) {
        
                                        // it is there, remove
                                        this.props.dispatch(cartItemAddonRemove(theAddon.id));
                                    }
                                    else {
        
                                        // it isn't there, add it
                                        this.props.dispatch(cartItemAddonAdd(theAddon.id));
                                    }
                                }}
                                checked={this.props.cartItem.addons.some((addon) => addon == theAddon.id)}
                                key={theAddon.id}
                                addon={theAddon}
                            >
                                {theAddon.name} {(theAddon.price > 0) ? ' - '+ theAddon.price : ''}
                                
                               

                            </FoodItemAddonSelection>
                        );
                    })}
                </div>
            )
        }
    }

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'completed':
                return this.renderCompleted();

            default:
                return this.renderInfo();
        }
    }

    renderCompleted() {
        return (
            <MenuItemAdded 
                item={this.props.foodItem} 
                handleClose={this.handleClose}
                handleCart={this.handleCart}
            />
        );
    }

    renderInfo() {
        return (
            <div className="food-item-modal-bottom-margin">
                <div className="menu-item-window">
                    <MenuItemInformation item={this.props.foodItem} />
                        
                    {this.renderFoodItemPricesAndChoices()}
                    {this.renderModifiers()}
                    {this.renderFoodItemAddons()}

                    <MenuItemInstructions 
                        placeholder="Any special instructions?"
                    />
                    <p className="disclaimer">
                        Please note: Addons and substitutions requested via special
                        instructions that are subject to extra pricing may not be honoured by the 
                        restaurant.
                    </p>
                </div>
                <div className="fixed-wrapper-for-add-to-order">

                    <MenuItemSubmitButton
                        itemtype="fooditem"
                        price={generateFoodItemPrice(this.props.foodItem, this.props.cartItem)}
                        showCompleted={this.showCompleted}
                    />
                    </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                isOpen={this.props.open}
                contentLabel="View Food"
                overlayClassName="modal-overlay"
                className="modal-window"
            >
                <div>
                    <ModalCloseButton 
                        clickAction={() => { this.props.dispatch(closeFoodItem()) }} 
                    />
                    
                    {this.renderActivePanel()}
                </div>

            </Modal>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        curPanel: state.panels.foodItem,
        foodItem: state.currentMenuItem.item,
        cartItem: state.cartItem,
        open: state.modals.foodItem
    };
};

export default connect(mapStateToProps)(ViewFoodItemModal);
